export default "__VITE_ASSET__CYBPq_dc__"